export default __webpack_public_path__ + "images/Coronal_View_of_Upper_Lip_Nose_Nostrils_dark.8184b8d1a2b641dde6524c4dd2a4995a.png";